/** @format */

import React from 'react'
import { _$, Icon, Button, Form, Input, Select, Option, Tag } from '@king-design/react'
import styled from 'styled-components'
import { cloneDeep } from 'lodash'
import { handleParamsCase } from 'src/utils/common'

export type CallbackTypeValueProp = { CallbackType: string; Url: string }
export type CallbackValueProp = CallbackTypeValueProp | string

interface AlarmCallBackProps {
  showCallbackType?: boolean
  value?: CallbackValueProp[]
  onChange?: (data: CallbackValueProp[]) => void
  maxLength?: number
  style?: React.CSSProperties
  className?: string
  readonly?: boolean
}

export const TypeEnum = {
  feishu: _$('飞书'),
  dingtalk: _$('钉钉'),
  wecom: _$('企业微信'),
  wps: _$('WPS协作'),
  custom: _$('自定义')
}

export const urlNoticeScheme = {
  CallbackType: {
    title: _$('类型'),
    width: '100',
    template: item => {
      return TypeEnum[item?.CallbackType] || ''
    }
  },
  Url: {
    title: 'URL'
  }
}

// 结果
export const urlNoticeResultScheme = {
  CallbackType: {
    title: _$('类型'),
    width: '100',
    template: item => {
      return TypeEnum[item?.CallbackType] || ''
    }
  },
  URL: {
    title: 'URL'
  },
  Result: {
    title: _$('结果'),
    template: item => {
      const { Result } = item
      return (
        <Tag type={Result === 'success' ? 'success' : 'danger'}>
          {Result === 'success' ? _$('发送成功') : Result}
        </Tag>
      )
    }
  }
}

// 把字符串转换成带类型的
export const handleCallbackType = values => {
  return values?.map(item => {
    if (typeof item === 'string') {
      return {
        CallbackType: 'custom',
        Url: item
      }
    } else {
      return handleParamsCase(item)
    }
  })
}

const AlarmCallBack: React.FC<AlarmCallBackProps> = ({
  value = [],
  onChange,
  maxLength = 10,
  style,
  className,
  readonly = false,
  showCallbackType = true
}) => {
  return (
    <div className={className} style={style || {}}>
      {readonly ? (
        <div>
          {value?.length
            ? value?.map(item => {
                if (showCallbackType) {
                  const { CallbackType, Url } = item as CallbackTypeValueProp
                  return (
                    <p key={`${CallbackType}-${Url}`}>
                      {showCallbackType
                        ? _$(TypeEnum[CallbackType]) || `${_$('自定义')} - { Url }`
                        : Url}
                    </p>
                  )
                } else {
                  return <p key={item as string}>{item as string}</p>
                }
              })
            : '-'}
        </div>
      ) : (
        <>
          <Form labelWidth={0}>
            {Array.isArray(value)
              ? value.map((item, index) => {
                  const { CallbackType, Url } = item as CallbackTypeValueProp
                  return (
                    <div className="callback_item" key={index}>
                      <Input
                        slotPrepend={
                          showCallbackType ? (
                            <Select
                              value={CallbackType}
                              width={120}
                              onChangeValue={val => {
                                const clone = cloneDeep(value)
                                clone[index] = { CallbackType: val, Url }
                                onChange && onChange(clone)
                              }}
                            >
                              {Object.keys(TypeEnum).map(key => (
                                <Option key={key} value={key}>
                                  {_$(TypeEnum[key])}
                                </Option>
                              ))}
                            </Select>
                          ) : undefined
                        }
                        value={showCallbackType ? Url : (item as string)}
                        placeholder={_$(
                          '填写公网可访问到的URL作为回调接口地址,例如:https://console.ksyun.com:8080/callback'
                        )}
                        onChangeValue={val => {
                          const clone = cloneDeep(value)
                          clone[index] = showCallbackType ? { CallbackType, Url: val } : val
                          onChange && onChange(clone)
                        }}
                      />
                      <a
                        className="delete_callback"
                        onClick={() => {
                          const clone = cloneDeep(value)
                          clone.splice(index, 1)
                          onChange && onChange(clone)
                        }}
                      >
                        {_$('删除')}
                      </a>
                    </div>
                  )
                })
              : null}
          </Form>
          <p className="add_callback">
            <Button
              disabled={value.length >= maxLength}
              type="link"
              onClick={() => {
                const mergeCallback = showCallbackType
                  ? [...value, { CallbackType: 'custom', Url: '' }]
                  : ([...value, ''] as string[])
                onChange && onChange(mergeCallback)
              }}
            >
              <Icon color="#0091ea" className="ion-plus-round" />
              {_$('新建回调')}
            </Button>
          </p>
        </>
      )}
    </div>
  )
}

export default styled(AlarmCallBack)`
  .callback_item {
    display: flex;
    padding-bottom: 16px;
    .k-input {
      width: calc(100% - 32px);
      .k-input-wrapper {
        border-radius: 0 4px 4px 0;
      }
    }
    .k-form-error {
      top: 32px;
    }
  }
  .delete_callback {
    margin-bottom: 0;
    line-height: 32px;
    margin-left: 8px;
  }
  .add_callback {
    line-height: 32px;
    margin-bottom: 0;
  }
`
